import { render, staticRenderFns } from "./service-flight.vue?vue&type=template&id=b16fedca&"
import script from "./service-flight.vue?vue&type=script&lang=js&"
export * from "./service-flight.vue?vue&type=script&lang=js&"
import style0 from "./service-flight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports